import { authApiInstance } from "./api";

// send register request
const register = (email, password, csrfToken) => {
  return authApiInstance.post("/auth/register", {
    email,
    password,
  }, {
    headers: { "X-CSRF-Token": csrfToken }
  });
};

// Send logging in request
const login = async (email, password, csrfToken) => {
  const response = await authApiInstance.post("/auth/login", {
    email,
    password,
  }, {
    headers: { "X-CSRF-Token": csrfToken }
  });
  // After login, do not store token in localStorage. Use cookies set by API.
  // Instead, fetch user info from /me endpoint.
  return response.data;
};

// Send request to API to get new token
const refresh = async (csrfToken) => {
  // No need to send refresh_token explicitly, API uses cookie
  const response = await authApiInstance.post("/auth/refresh", {}, {
    headers: { "X-CSRF-Token": csrfToken }
  });
  // After refresh, fetch user info from /me endpoint if needed
  console.log(response.data)
  return response.data;
};

// logout user
const logout = async (csrfToken) => {
  // Call API to clear cookies
  await authApiInstance.post("/auth/logout", {}, {
    headers: {
      "X-CSRF-Token": csrfToken,
    }
  });
};
// Fetch current user info (after login/register/refresh)
const getCurrentUser = async () => {
  const response = await authApiInstance.get("/auth/me");
  return response.data;
};

// Fetch CSRF token if needed
const getCsrfToken = async () => {
  const response = await authApiInstance.get("/auth/csrf");
  return response.data.csrf_token;
};

export default {
  register,
  login,
  refresh,
  logout,
  getCurrentUser,
  getCsrfToken,
};

